import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  
  export const fetchCars = () => (dispatch) => {
  
    const {
        carsRef
    } = firebase;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        console.log('Add Car: Starting to add car', car);
        try {
          const result = await push(carAddRef, car);
          console.log('Add Car: Successfully added car. Firebase result:', result);
        } catch (error) {
          console.error('Add Car: Error adding car', error);
        }
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      await uploadBytesResumable(carImage(car.id),car.car_image);
      let image = await getDownloadURL(carImage(car.id));
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: image
        });
      }   
    }
     else {
        set(carEditRef(car.id),car);
    }
  }

  export const updateUserCarWithImage = (newData, blob, additionalImages = {}) => (dispatch) => {
    const {
      auth,
      carAddRef,
      singleUserRef,
      carImage,
      carInsuranceCopy,
      carPucCopy,
      carFitnessDocument,
      carVehiclePermitCopy,
      carVehicleImageBack,
      carRegistrationImage,
      carRegistrationImageBack
    } = firebase;

    var carId = push(carAddRef).key;

    // Upload main car image
    uploadBytesResumable(carImage(carId), blob).then(() => {
      if (typeof blob.close === 'function') {
        blob.close();
      }
      return getDownloadURL(carImage(carId))
    }).then((url) => {
      newData.car_image = url;
      console.log('updateUserCarWithImage: car_image URL set', url);
      // Upload additional images if provided
      const uploadPromises = [];
      
      // Helper function to create upload promises with error handling
      const createUploadPromise = (uploadFunction, blob, getUrlFunction, fieldName, fieldNameLog) => {
        return uploadFunction(blob)
          .then(() => {
            if (typeof blob.close === 'function') {
              blob.close();
            }
          })
          .then(() => getUrlFunction())
          .then((url) => {
            newData[fieldName] = url;
            console.log(`updateUserCarWithImage: ${fieldNameLog} URL set`, url);
            return true; // Success
          })
          .catch((err) => {
            console.error(`updateUserCarWithImage: ${fieldNameLog} upload error`, err);
            // Don't reject the promise, just return false to indicate failure
            return false; // Failure, but don't break the chain
          });
      };

      if (additionalImages.insuranceCopyBlob) {
        uploadPromises.push(
          createUploadPromise(
            (blob) => uploadBytesResumable(carInsuranceCopy(carId), blob),
            additionalImages.insuranceCopyBlob,
            () => getDownloadURL(carInsuranceCopy(carId)),
            'insuranceCopy',
            'insuranceCopy'
          )
        );
      }
      
      if (additionalImages.pucCopyBlob) {
        uploadPromises.push(
          createUploadPromise(
            (blob) => uploadBytesResumable(carPucCopy(carId), blob),
            additionalImages.pucCopyBlob,
            () => getDownloadURL(carPucCopy(carId)),
            'pucCopy',
            'pucCopy'
          )
        );
      }
      
      if (additionalImages.fitnessDocumentBlob) {
        uploadPromises.push(
          createUploadPromise(
            (blob) => uploadBytesResumable(carFitnessDocument(carId), blob),
            additionalImages.fitnessDocumentBlob,
            () => getDownloadURL(carFitnessDocument(carId)),
            'fitnessDocument',
            'fitnessDocument'
          )
        );
      }
      
      if (additionalImages.vehiclePermitCopyBlob) {
        uploadPromises.push(
          createUploadPromise(
            (blob) => uploadBytesResumable(carVehiclePermitCopy(carId), blob),
            additionalImages.vehiclePermitCopyBlob,
            () => getDownloadURL(carVehiclePermitCopy(carId)),
            'vehiclePermitCopy',
            'vehiclePermitCopy'
          )
        );
      }
      
      if (additionalImages.vehicleImageBackBlob) {
        uploadPromises.push(
          createUploadPromise(
            (blob) => uploadBytesResumable(carVehicleImageBack(carId), blob),
            additionalImages.vehicleImageBackBlob,
            () => getDownloadURL(carVehicleImageBack(carId)),
            'vehicleImageBack',
            'vehicleImageBack'
          )
        );
      }
      
      if (additionalImages.registrationImageBlob) {
        uploadPromises.push(
          createUploadPromise(
            (blob) => uploadBytesResumable(carRegistrationImage(carId), blob),
            additionalImages.registrationImageBlob,
            () => getDownloadURL(carRegistrationImage(carId)),
            'registrationImage',
            'registrationImage'
          )
        );
      }
      
      if (additionalImages.registrationImageBackBlob) {
        uploadPromises.push(
          createUploadPromise(
            (blob) => uploadBytesResumable(carRegistrationImageBack(carId), blob),
            additionalImages.registrationImageBackBlob,
            () => getDownloadURL(carRegistrationImageBack(carId)),
            'registrationImageBack',
            'registrationImageBack'
          )
        );
      }
      
      // Wait for all image uploads to complete (success or failure)
      return Promise.all(uploadPromises);
    }).then((results) => {
      // Log which uploads succeeded or failed
      console.log('updateUserCarWithImage: Upload results', results);
      // Save car data with all successfully uploaded image URLs
      console.log('updateUserCarWithImage: final newData', newData);
      return set(child(carAddRef, carId), newData)
    }).then(() => {
      if(newData.active){
        let updateData = {
          carType: newData.carType,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          other_info: newData.other_info,
          car_image: newData.car_image,
          insuranceCopy: newData.insuranceCopy,
          pucCopy: newData.pucCopy,
          fitnessDocument: newData.fitnessDocument,
          vehiclePermit: newData.vehiclePermit,
          vehiclePermitCopy: newData.vehiclePermitCopy,
          vehicleImageBack: newData.vehicleImageBack,
          registrationImage: newData.registrationImage,
          registrationImageBack: newData.registrationImageBack,
          carApproved: newData.approved,
          updateAt: new Date().getTime()
        };
        return update(singleUserRef(auth.currentUser.uid), updateData);
      }
    }).catch((error) => {
      console.error('updateUserCarWithImage: Error in car image upload process', error);
      // Handle the error appropriately, possibly dispatch an error action
      throw error;
    });
  };

  export const updateCarWithImages = (carData, mainImageBlob = null, additionalImages = {}) => (dispatch) => {
    const {
      carEditRef,
      singleUserRef,
      carImage,
      carInsuranceCopy,
      carPucCopy,
      carFitnessDocument,
      carVehiclePermitCopy,
      carVehicleImageBack,
      carRegistrationImage,
      carRegistrationImageBack
    } = firebase;

    const carId = carData.id;
    
    // Upload main car image if provided
    if (mainImageBlob) {
      uploadBytesResumable(carImage(carId), mainImageBlob)
        .then(() => {
          if (typeof mainImageBlob.close === 'function') {
            mainImageBlob.close();
          }
        })
        .then(() => getDownloadURL(carImage(carId)))
        .then((url) => {
          carData.car_image = url;
          console.log('updateCarWithImages: car_image URL set', url);
        })
        .catch((err) => {
          console.error('updateCarWithImages: car_image upload error', err);
        });
    }

    // Upload additional images if provided
    const uploadPromises = [];
    
    // Helper function to create upload promises with error handling
    const createUploadPromise = (uploadFunction, blob, getUrlFunction, fieldName, fieldNameLog) => {
      return uploadFunction(blob)
        .then(() => {
          if (typeof blob.close === 'function') {
            blob.close();
          }
        })
        .then(() => getUrlFunction())
        .then((url) => {
          carData[fieldName] = url;
          console.log(`updateCarWithImages: ${fieldNameLog} URL set`, url);
          return true; // Success
        })
        .catch((err) => {
          console.error(`updateCarWithImages: ${fieldNameLog} upload error`, err);
          // Don't reject the promise, just return false to indicate failure
          return false; // Failure, but don't break the chain
        });
    };

    if (additionalImages.insuranceCopyBlob) {
      uploadPromises.push(
        createUploadPromise(
          (blob) => uploadBytesResumable(carInsuranceCopy(carId), blob),
          additionalImages.insuranceCopyBlob,
          () => getDownloadURL(carInsuranceCopy(carId)),
          'insuranceCopy',
          'insuranceCopy'
        )
      );
    }
    
    if (additionalImages.pucCopyBlob) {
      uploadPromises.push(
        createUploadPromise(
          (blob) => uploadBytesResumable(carPucCopy(carId), blob),
          additionalImages.pucCopyBlob,
          () => getDownloadURL(carPucCopy(carId)),
          'pucCopy',
          'pucCopy'
        )
      );
    }
    
    if (additionalImages.fitnessDocumentBlob) {
      uploadPromises.push(
        createUploadPromise(
          (blob) => uploadBytesResumable(carFitnessDocument(carId), blob),
          additionalImages.fitnessDocumentBlob,
          () => getDownloadURL(carFitnessDocument(carId)),
          'fitnessDocument',
          'fitnessDocument'
        )
      );
    }
    
    if (additionalImages.vehiclePermitCopyBlob) {
      uploadPromises.push(
        createUploadPromise(
          (blob) => uploadBytesResumable(carVehiclePermitCopy(carId), blob),
          additionalImages.vehiclePermitCopyBlob,
          () => getDownloadURL(carVehiclePermitCopy(carId)),
          'vehiclePermitCopy',
          'vehiclePermitCopy'
        )
      );
    }
    
    if (additionalImages.vehicleImageBackBlob) {
      uploadPromises.push(
        createUploadPromise(
          (blob) => uploadBytesResumable(carVehicleImageBack(carId), blob),
          additionalImages.vehicleImageBackBlob,
          () => getDownloadURL(carVehicleImageBack(carId)),
          'vehicleImageBack',
          'vehicleImageBack'
        )
      );
    }
    
    if (additionalImages.registrationImageBlob) {
      uploadPromises.push(
        createUploadPromise(
          (blob) => uploadBytesResumable(carRegistrationImage(carId), blob),
          additionalImages.registrationImageBlob,
          () => getDownloadURL(carRegistrationImage(carId)),
          'registrationImage',
          'registrationImage'
        )
      );
    }
    
    if (additionalImages.registrationImageBackBlob) {
      uploadPromises.push(
        createUploadPromise(
          (blob) => uploadBytesResumable(carRegistrationImageBack(carId), blob),
          additionalImages.registrationImageBackBlob,
          () => getDownloadURL(carRegistrationImageBack(carId)),
          'registrationImageBack',
          'registrationImageBack'
        )
      );
    }
    
    // Wait for all image uploads to complete (success or failure), then update car data
    return Promise.all(uploadPromises).then((results) => {
      // Log which uploads succeeded or failed
      console.log('updateCarWithImages: Upload results', results);
      // Save car data with all successfully uploaded image URLs
      console.log('updateCarWithImages: final carData', carData);
      return set(carEditRef(carId), carData);
    }).then(() => {
      if(carData.active && carData.driver){
        let updateData = {
          carType: carData.carType,
          vehicleNumber: carData.vehicleNumber,
          vehicleMake: carData.vehicleMake,
          vehicleModel: carData.vehicleModel,
          other_info: carData.other_info,
          car_image: carData.car_image,
          insuranceCopy: carData.insuranceCopy,
          pucCopy: carData.pucCopy,
          fitnessDocument: carData.fitnessDocument,
          vehiclePermit: carData.vehiclePermit,
          vehiclePermitCopy: carData.vehiclePermitCopy,
          vehicleImageBack: carData.vehicleImageBack,
          registrationImage: carData.registrationImage,
          registrationImageBack: carData.registrationImageBack,
          carApproved: carData.approved,
          updateAt: new Date().getTime()
        };
        return update(singleUserRef(carData.driver), updateData);
      }
    }).catch((error) => {
      console.error('updateCarWithImages: Error in car image upload process', error);
      // Handle the error appropriately, possibly dispatch an error action
      throw error;
    });
  };
